import type { ParsedUrlQuery } from 'querystring';
import type { ReactNode } from 'react';

export type SideBarItemProps = {
  showBadge?: boolean;
  checkIfActive?: (pathname: string, query?: ParsedUrlQuery) => boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  icon?: ReactNode;
  items?: SideBarItemProps[];
  label?: ReactNode;
  path?: string;
  title: string;
};

// Copied rather than sorted in place: callers read the declared order off the array they pass in.
export function sortedActiveItems(items: readonly SideBarItemProps[]): SideBarItemProps[] {
  return [...items].sort((a, b) => (Number(a.disabled) || -1) - (Number(b.disabled) || -1));
}
